/**
 * Created by jack on 2018/5/23.
 */
// (function(win, document) {
        function Scroll(selector, opts) {
            this.scroller = document.querySelector(selector);
            this.childNode = this.scroller.childNodes[0];
            this.options = {
                step: true,
                defaultPlace: 0,
                callback: null
            };
            this.startPageY = 0;
            this.startTime = 0;
            this.endTime = 0;
            this.offsetTop = 0;
            this.scrollerHeight = this.scroller.clientHeight;
            this.childNodeHeight = this.childNode.clientHeight;
            this.scrollHeight = this.childNodeHeight - this.scrollerHeight;
            var nodes = this.childNode.childNodes;
            //每次滚动时的固定高度 为了卡准dom元素
            this.stepLen = nodes.length > 0 ? nodes[0].clientHeight : 0;
            for (var p in opts) {
                this.options[p] = opts[p];
            }
            var d = this.options.defaultPlace ? this.options.defaultPlace : 0;
            this.scrollTo(0, d);
            this._start();
            this._move();
            this._end()
        }
        Scroll.prototype = {
            _start: function() {
                var that = this;
                that.scroller.addEventListener('touchstart', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    that.startTime = that.getTime();
                    var evt = e.touches ? e.touches[0] : e;
                    that.startPageY = evt.pageY;
                    that.browserVendor('transition', 'none')
                }, false)
            },
            _move: function() {
                var that = this;
                that.scroller.addEventListener('touchmove', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var time = that.getTime();
                    var evt = e.touches ? e.touches[0] : e;
                    var dY = evt.pageY - that.startPageY; //y方向变化值
                    var tY = dY + that.offsetTop; //y目标值
                    if (time - that.endTime > 300 && Math.abs(dY) < 10) {
                        return
                    }
                    if (tY > 0) {
                        tY /= 3
                    } else if (Math.abs(tY) > Math.abs(that.scrollHeight)) {
                        tY = Math.abs(that.scrollHeight) - Math.abs(tY);
                        tY = tY / 3 - that.scrollHeight
                    }
                    that.browserVendor('transform', 'translate(0, ' + tY + 'px)')
                }, false)
            },
            _end: function() {
                var that = this;
                that.scroller.addEventListener('touchend', function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    that.endTime = that.getTime();
                    var dTime = that.endTime - that.startTime; //按下和松开的时间间隔
                    var evt = e.changedTouches ? e.changedTouches[0] : e;
                    var dY = evt.pageY - that.startPageY; //y方向变化
                    that.offsetTop += dY;
                    if ((that.offsetTop > 0) || (Math.abs(that.offsetTop) > Math.abs(that.scrollHeight))) {
                        that.browserVendor('transition', 'all 500ms')
                    } else if (dTime < 300) {
                        //快速滑动时保留最多2000ms的惯性
                        var speed = Math.abs(dY) / dTime;
                        var duration = dTime * speed * 20;
                        duration = duration > 2000 ? 2000 : duration;
                        that.offsetTop += dY * speed * 10;
                        that.browserVendor('transitionProperty', 'all');
                        that.browserVendor('transitionDuration', duration + 'ms');
                        that.browserVendor('transitionTimingFunction', 'cubic-bezier(0.1, 0.57, 0.1, 1)')
                    } else {
                        that.browserVendor('transition', 'all 500ms')
                    }
                    if (that.offsetTop > 0) {
                        that.offsetTop = 0
                    } else if (Math.abs(that.offsetTop) > Math.abs(that.scrollHeight)) {
                        that.offsetTop = -that.scrollHeight
                    }
                    if (that.options.step && that.stepLen > 0) {
                        var offsetTop = that.offsetTop;
                        var num = Math.abs(offsetTop % that.stepLen);
                        var i = that.stepLen / 2;
                        var tY = (num >= i) ? (offsetTop - that.stepLen + num) : (offsetTop + num);
                        var index = parseInt(Math.abs(tY) / that.stepLen);
                        that.options.callback({
                            index: index,
                            node: that.childNode.childNodes
                        });
                        that.offsetTop = tY
                    }
                    that.browserVendor('transform', 'translate(0, ' + that.offsetTop + 'px)')
                }, false)
            },
            scrollTo: function(x, y, a) {
                var that = this;
                if (a && a > 0) {
                    that.browserVendor('transitionProperty', 'all');
                    that.browserVendor('transitionDuration', a + 'ms');
                    that.browserVendor('transitionTimingFunction', 'cubic-bezier(0.1, 0.57, 0.1, 1)')
                } else {
                    that.browserVendor('transition', 'none')
                }
                y = -y;
                that.offsetTop = y;
                that.browserVendor('transform', 'translate(0, ' + y + 'px)')
            },
            refresh: function() {
                this.childNode = this.scroller.childNodes[0];
                this.startPageY = 0;
                this.startTime = 0;
                this.endTime = 0;
                this.offsetTop = 0;
                this.scrollerHeight = this.scroller.clientHeight;
                this.childNodeHeight = this.childNode.clientHeight;
                this.scrollHeight = this.childNodeHeight - this.scrollerHeight;
                var a = this.childNode.childNodes;
                this.stepLen = a.length > 0 ? a[0].clientHeight : 0;
                this.scrollTo(0, 0, 500)
            },
            browserVendor: function(a, b) {
                var c = this;
                var d = ['t', 'WebkitT', 'MozT', 'msT', 'OT'], styleObj, len = d.length;
                var e = c.childNode.style;
                for (var i = 0; i < len; i++) {
                    styleObj = d[i] + a.substr(1);
                    if (styleObj in e) {
                        e[styleObj] = b
                    }
                }
            },
            getTime: function() {
                return parseInt(new Date().getTime())
            }
        };
        let Picker = function (opts) {
            this.dataListTwo = null;
            this.dataListThree = null;
            this.dataListFour = null;
            this.arrayDepth = 1;
            this.scrollArray = [];
            this.textArray = [];
            this.isScrollTo = false;
            this.options = {
                "title": '请选择',
                "defaultValue": '',
                "type": '',
                "data": [],
                "keys": null,
                "callBack": null
            };
            for (var i in opts) {
                this.options[i] = opts[i]
            }
            if (!this.options.keys && this.options.data.length <= 0) {
                return
            }
            if (!this.options.type || this.options.type > 3 || this.options.type < 1) {
                this.getArrayDepth(opts.data)
            } else {
                this.arrayDepth = this.options.type
            }
            var keys = this.options.keys;
            this.keyId = keys.id;
            this.keyValue = keys.value;
            this.keyData = keys.childData;
            this.defaultArray = ['', '', ''];
            if (this.options.defaultValue) {
                var c = this.options.defaultValue;
                var d = c.split(" ");
                if (d.length > 0) {
                    for (var e = 0; e < d.length; e++) {
                        this.defaultArray[e] = d[e]
                    }
                }
            }
            this.FillData();
            this.eventClick()
        }
        Picker.prototype = {
            FillData: function() {
                var that = this;
                that.enterNodesBlur();
                var mask = document.querySelector(".zx_mask");
                if (mask) {
                    document.body.removeChild(mask)
                }
                var title = that.options.title ? that.options.title : '请选择';
                var div = document.createElement("div");
                div.className = "zx_mask";
                var html = '<div class="zx_select showPicker">' +
                    '<header><button class="nav_left picker-cancel">取消</button>' +
                    '<div class="nav_title">' + title + '</div><button class="nav_right picker-ok">确定</button></header>' +
                    '<div class="ub"><div class="ub-f1 picker-wrapper" id="picker-wrapper0"><ul></ul></div>';
                if (that.arrayDepth >= 2) {
                    html += '<div class="ub-f1 picker-wrapper" id="picker-wrapper1"><ul></ul></div>'
                }
                if (that.arrayDepth >= 3) {
                    html += '<div class="ub-f1 picker-wrapper" id="picker-wrapper2"><ul></ul></div>'
                }
                if(that.arrayDepth >= 4){
                    html += '<div class="ub-f1 picker-wrapper" id="picker-wrapper3"><ul></ul></div>'
                }
                if (that.arrayDepth >=5){
                    html += '<div class="ub-f1 picker-wrapper" id="picker-wrapper4"><ul></ul></div>'
                }
                html += '<div class="sel_top"></div><div class="sel_bottom"></div>';
                html += '<div class="sel_middle"></div></div></div>';
                div.innerHTML = html;
                document.body.appendChild(div);
                var sW = parseFloat(100 / that.arrayDepth).toFixed(3) + "%";
                var wrapers = document.querySelectorAll('.picker-wrapper');
                for (var i = 0; i < wrapers.length; i++) {
                    wrapers[i].style.minWidth = sW;
                    wrapers[i].style.maxWidth = sW
                }
                if (that.arrayDepth >= 1) {
                    that.showScrollList(this.options.data, 0, true)
                }
                setTimeout(function() {
                    // document.querySelector('.zx_select').style.height = '245px'
                    document.querySelector('.zx_select').style.height = '65.33vw'
                }, 0)
            },
            scrollInit: function(d, e) {
                var f = this;
                var g = document.querySelector('#picker-wrapper0').childNodes[0];
                var h = g.childNodes[0].clientHeight;
                var i = '#picker-wrapper' + d;
                f.scrollArray[d] = new Scroll(i,{
                    step: h,
                    defaultPlace: h * e,
                    callback: function(a) {
                        var b = a.index + 2;
                        var c = a.node[b];
                        f.SetItemList(c, d)
                    }
                });
                f.add_EventListen()
            },
            SetItemList: function(a, b) {
                var c = this;
                if (a) {
                    var d = c.keyId;
                    var e = c.keyValue;
                    var f = {};
                    f[e] = a.textContent;
                    f[d] = a.attributes[0].value;
                    c.defaultArray = ['', '', ''];
                    if (b == 0) {
                        c.defaultArray[b] = f[e];
                        c.showScrollList(c.options.data, 0)
                    } else if (b == 1) {
                        c.defaultArray[b] = f[e];
                        c.showScrollList(c.dataListTwo, 1)
                    } else if (b == 2){
                        c.defaultArray[b] = f[e];
                        c.showScrollList(c.dataListThree, 2)
                    }else if (b == 3){
                        c.defaultArray[b] = f[e];
                        c.showScrollList(c.dataListFour, 3)
                    }
                } else {
                    var f = ""
                }
                c.textArray[b] = f
            },
            showScrollList: function(a, b, c) {
                var d = this;
                var e = d.keyId;
                var f = d.keyValue;
                var g = d.keyData;
                var h = '<li></li><li></li>', defaultNum, childData = [];
                if (d.defaultArray[b]) {
                    var j = false;
                    for (var i = 0; i < a.length; i++) {
                        if (d.defaultArray[b] && d.defaultArray[b] == a[i][f]) {
                            j = true;
                            defaultNum = i;
                            if (g && a[i][g]) {
                                childData = a[i][g]
                            }
                            d.setDefaultItem(b, a[i][f], a[i][e])
                        }
                        h += '<li data-id="' + a[i][e] + '">' + a[i][f] + '</li>'
                    }
                    if (!j) {
                        if (g && a[0][g]) {
                            childData = a[0][g]
                        }
                        d.setDefaultItem(b, a[0][f], a[0][e])
                    }
                } else {
                    for (var i = 0; i < a.length; i++) {
                        h += '<li data-id="' + a[i][e] + '">' + a[i][f] + '</li>'
                    }
                    if (g && a[0][g]) {
                        childData = a[0][g]
                    }
                    d.setDefaultItem(b, a[0][f], a[0][e])
                }
                h += '<li></li><li></li>';
                document.querySelector('#picker-wrapper' + b).childNodes[0].innerHTML = h;
                var k = b + 1;
                if (c) {
                    d.scrollInit(b, defaultNum);
                    if (k < d.arrayDepth && childData.length > 0) {
                        d.showScrollList(childData, k, true)
                    }
                } else {
                    if (k < d.arrayDepth) {
                        if (childData.length > 0) {
                            d.showScrollList(childData, k)
                        }
                        setTimeout(function() {
                            d.scrollArray[k].refresh()
                        }, 0)
                    }
                }
                if (b == 0) {
                    d.dataListTwo = childData
                } else if (b == 1){
                    d.dataListThree = childData
                } else if (b == 2){
                    d.dataListFour = childData
                }
            },
            setDefaultItem: function(a, b, c) {
                var d = this;
                var e = d.keyId;
                var f = d.keyValue;
                var g = {};
                g[f] = b;
                g[e] = c;
                d.textArray[a] = g
            },
            eventClick: function() {
                var g = this;
                //事件改为tap 避免蹭到后也消失
                document.querySelector('.picker-cancel').addEventListener("click", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    g.HidePicker()
                });
                document.querySelector('.picker-ok').addEventListener("click", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    var a = [];
                    var c = g.options.keys;
                    for (var i = 0; i < g.textArray.length; i++) {
                        a.push(g.textArray[i]);
                    }
                    if (g.options.callBack) {
                        g.options.callBack(a)
                    }
                    g.HidePicker()
                })
            },
            HidePicker: function() {
                var b = this;
                var zx_select= document.querySelector('.zx_select');
                if(!zx_select){
                    return;
                }
                document.querySelector('.zx_select').style.height = '0';
                b.remove_EventListen();
                setTimeout(function() {
                    var a = document.querySelector('.zx_mask');
                    document.body.removeChild(a);
                    b.destroy()
                }, 200)
            },
            getArrayDepth: function(a) {
                var b = this;
                var c = a[0], index = "";
                for (var i in c) {
                    if (Array.isArray(c[i]) && c[i].length != 0) {
                        index = i;
                        b.arrayDepth++;
                        break
                    }
                }
                if (index) {
                    b.getArrayDepth(c[index])
                }
            },
            enterNodesBlur: function() {
                var a = document.querySelectorAll('input');
                for (var m = 0; m < a.length; m++) {
                    a[m].blur()
                }
                var b = document.querySelectorAll('textarea');
                for (var n = 0; n < b.length; n++) {
                    b[n].blur()
                }
            },
            touchDefault: function(e) {
                e.preventDefault()
            },
            touchStop: function(e) {
                e.stopPropagation();
                e.preventDefault()
            },
            add_EventListen: function() {
                var a = this;
                document.addEventListener('touchmove', a.touchDefault, false)
            },
            remove_EventListen: function() {
                var a = this;
                document.removeEventListener('touchmove', a.touchDefault, false)
            },
            destroy: function() {
                var a = this;
                a.dataListTwo = null;
                a.dataListThree = null;
                a.dataListFour = null;
                a.options = null;
                a.arrayDepth = 1;
                a.scrollArray = [];
                a.textArray = [];
                a.isScrollTo = false;
                this.keyId = '';
                this.keyValue = '';
                this.keyData = '';
                this.defaultArray = ['', '', '']
            }
        };
        // if (typeof module != 'undefined' && module.exports) {
        //     module.exports = Picker
        // } else if(typeof define =="function" && define.amd){
        //     define(function(){
        //         return Picker;
        //     });
        // }else{
        //     win.Picker = Picker
        // }
        export {Picker}
    // }
// )(window, documentument);
